baseConfig.$inject = [
  '$locationProvider',
  'languageServiceProvider',
  'tmhDynamicLocaleProvider',
  '$qProvider',
  '$sceProvider',
  'DemoAccountServiceProvider',
  '$httpProvider'
];

export function baseConfig(
  $locationProvider,
  languageServiceProvider,
  tmhDynamicLocaleProvider,
  $qProvider,
  $sceProvider,
  DemoAccountServiceProvider,
  $httpProvider
) {
  $locationProvider.hashPrefix('');
  $qProvider.errorOnUnhandledRejections(true);
  // do not restrict references to external URLS at all as we have full controll
  //$sceDelegateProvider.resourceUrlWhitelist(['.*']);
  $sceProvider.enabled(false);

  initLocalization();

  initDemoAccountService();

  initHttpProvider();

  function initLocalization() {
    const uiLocale = app.languages.current() || app.credentials.locale;
    const angularLocale = languageServiceProvider.toAngularLocale(uiLocale);
    const datePickerLocale = languageServiceProvider.toJQueryUiDatePickerLocale(uiLocale);

    // configure tmhDynamicLocale plugin
    // tmh dynamic locale plugin will always load the default locale first, so we have to find the
    // correct locale already here
    tmhDynamicLocaleProvider.localeLocationPattern(
      '../node_modules/angular-i18n/angular-locale_{{locale}}.js'
    );
    tmhDynamicLocaleProvider.defaultLocale(angularLocale);

    // configure locale for jQuery UI's date picker
    $.datepicker.setDefaults($.datepicker.regional[datePickerLocale]);

    // Translations have been loaded by bootstrap process, Angular locale is loaded by initialization
    // of tmhDynamicLocale. Thus, we can inform languageService that nothing has to be done for the
    // current locale
    languageServiceProvider.setInitialLanguage(uiLocale);
  }

  /**
   * Copied from 'app/cfnConfig.js'!!!
   */
  function initDemoAccountService() {
    DemoAccountServiceProvider.setIsDemoAccount(
      app.credentials.userProperties['demo-account'] === 'true'
    );
  }

  /**
   * Copied from 'app/cfnConfig.js'!!!
   */
  function initHttpProvider() {
    //making parsing more robust. If Server defines content as json, but it's a string
    //convert it to a json parseable stringto prevent the defaultTransformResponse from throwing an exception.
    //if not, from Angular 1.6 onwards the cfnHttInterceptors get the Parsing Exception loosing all information
    //reqarding the response.
    $httpProvider.defaults.transformResponse.unshift(function(data, headers) {
      const contentType = headers('Content-Type');

      if (contentType && contentType.indexOf('json') > -1) {
        try {
          JSON.parse(data);
        } catch (e) {
          //this cannot be parsed as json directly
          if (data && typeof data === 'string') {
            try {
              //try to encode it as a parseable json string
              return '"' + data.replaceAll('"', '\\"') + '"';
            } catch (e) {
              //if this does not work either... then let it fail
            }
          }
        }
      }

      return data;
    });

    // register the interceptor as a service
    $httpProvider.interceptors.push('CfnHttpInterceptor');

    // Allow PATCH requests with JSON
    $httpProvider.defaults.headers.patch = {
      'Content-Type': 'application/json;charset=utf-8'
    };
  }
}
